<template>
    <div>
        <div class="box">
            <div class="headline">{{ trans('account') }}</div>
            <div class="row">
                <div class="title">{{ trans('display_name') }}</div>
                <div class="field notranslate">
                    <input
                        v-model="user.headline"
                        type="text"
                        name="headline"
                        class="form-control no-swiping"
                        v-bind:data-vv-as="trans('display_name')"
                        v-validate="{required: true, min: 3, max: 32}"
                        @focus="rememberProfileOldValue"
                        @change="saveProfileChange"
                    >
                </div>
            </div>
            <span class="form-error" :class="{'is-visible': errors.has('headline')}">
              {{ errors.first('headline') }}
            </span>

          <div class="row">
            <div class="title">{{ trans('display_link') }}</div>
            <div class="field notranslate">
              <input
                  v-model="user.handle"
                  type="text"
                  name="handle"
                  class="form-control no-swiping"
                  v-bind:data-vv-as="trans('display_link')"
                  v-validate="{required: true, min: 3, max: 15, regex:/^[a-zA-Z0-9\-_.]+$/}"
                  @focus="rememberProfileOldValue"
                  @change="saveProfileChange"
              >
            </div>
          </div>
          <span class="form-error" :class="{'is-visible': errors.has('handle')}">
              {{ errors.first('handle') }}
            </span>

            <div class="row">
                <div class="title">{{ trans('reg.birthdate') }}</div>
                <div class="field">
                    <input
                        v-if="isTouch() && isIos()" type="date"
                        v-model="user.dob"
                        class="form-control no-swiping datepicker-input-profile"
                        name="dob"
                        id="dob"
                        v-bind:max="maxAdultDate()"
                        v-bind:data-vv-as="trans('reg.birthdate')"
                        required
                        v-validate="{required: true, date_format: 'yyyy-MM-dd', date_between: ['1900-01-01', maxAdultDate(), true]}"
                        @change="saveProfileChange"
                    >
                    <DatePickerComponent
                        v-else
                        v-model="user.dob"
                        name="dob"
                        id="dob"
                        input-class="form-control no-swiping datepicker-input-profile"
                        v-bind:language="appLanguage"
                        v-bind:max="maxAdultDate()"
                        v-bind:toRight="true"
                        v-bind:data-vv-as="trans('reg.birthdate')"
                        v-bind:to-right="isMobile"
                        v-bind:v-validate="{required: true, date_format: 'yyyy-MM-dd', date_between: ['1900-01-01', maxAdultDate(), true]}"
                        required
                        @change="saveProfileChange"
                    ></DatePickerComponent>
                </div>
            </div>
            <span class="form-error" :class="{'is-visible': errors.has('dob')}">
              {{ errors.first('dob') }}
            </span>

            <div class="row">
                <div class="title">{{ trans('email') }}</div>
                <div class="field">
                    <input type="email" name="email" v-model="user.email"
                        v-bind:data-vv-as="trans('email')"
                        v-validate="'required|email'" class="form-control no-swiping"
                        @focus="rememberProfileOldValue" @change="saveProfileChange">
                  <span v-if="emailVerificationEnabled" @click="openVerifyEmailModal" :class="{'verify-icon':true, 'verified' : user.email_verified}"></span>
                </div>
            </div>
            <span class="form-error" :class="{'is-visible': errors.has('email')}">
              {{ errors.first('email') }}
            </span>

            <div class="row">
                <div class="title">{{ trans('password') }}</div>
                <div class="field">
                    <div type="password" class="form-control no-swiping" @click="showPasswordForm">{{ trans('change_password') }}</div>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('verify_age') }}</div>
                <div class="field">
                    <div v-if="user.age_verified_at" class="form-control no-swiping verified-text">
                        Verified
                        <span class="verify-icon verified"></span>
                    </div>
                    <div v-else class="form-control no-swiping" @click="startAgeVerification">{{ trans('start_verification') }}</div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="headline">Website content</div>
            <div class="settings-toggle-container" :class="{'first' : user.web_view_sensitive_events === 'no' && user.web_view_sensitive_content === 'no','second' : user.web_view_sensitive_events === 'yes' && user.web_view_sensitive_content === 'no','third' : user.web_view_sensitive_events === 'yes' && user.web_view_sensitive_content === 'yes'}">
              <div class="settings-toggle-container-item"
                   @click="setSensitive('safe','web')"
                  :class="{'active': user.web_view_sensitive_events === 'no' && user.web_view_sensitive_content === 'no'}">
                  Safe
              </div>
              <div class="settings-toggle-container-item"
                   @click="setSensitive('sensitive','web')"
                   :class="{'active': user.web_view_sensitive_events === 'yes' && user.web_view_sensitive_content === 'no'}">
                Sensitive
              </div>
              <div class="settings-toggle-container-item"
                   @click="setSensitive('explicit','web')"
                   :class="{'active': user.web_view_sensitive_events === 'yes' && user.web_view_sensitive_content === 'yes'}">
                Explicit
              </div>
            </div>
          <div class="headline">App content</div>
          <div class="settings-toggle-container" :class="{'first' : user.app_view_sensitive_events === 'no' && user.app_view_sensitive_media === 'no','second' : user.app_view_sensitive_events === 'yes' && user.app_view_sensitive_media === 'no','third' : user.app_view_sensitive_events === 'yes' && user.app_view_sensitive_media === 'yes'}">
            <div class="settings-toggle-container-item"
                 @click="setSensitive('safe','app')"
                 :class="{'active': user.app_view_sensitive_events === 'no' && user.app_view_sensitive_media === 'no'}">
              Safe
            </div>
            <div class="settings-toggle-container-item"
                 @click="setSensitive('sensitive','app')"
                 :class="{'active': user.app_view_sensitive_events === 'yes' && user.app_view_sensitive_media === 'no'}">
              Sensitive
            </div>
            <div class="settings-toggle-container-item"
                 @click="setSensitive('explicit','app')"
                 :class="{'pro': !userIsPro,'active': user.app_view_sensitive_events === 'yes' && user.app_view_sensitive_media === 'yes'}">
              Explicit
            </div>
          </div>
        </div>
        <div class="box">
            <div class="headline">PRO</div>
            <div class="row" id="buy-pro">
                <div class="title">{{ trans('hide_profile_completely') }}</div>
                <div class="field" v-if="userIsPro">
                    <div class="toggle-switch">
                        <input type="checkbox" id="invisible"
                               v-model="user.invisible"
                               true-value="yes"
                               false-value="no"
                               name="invisible"
                               @change="userUpdate">
                        <label for="invisible">
                            <span class="toggle-track"></span>
                        </label>
                    </div>
                </div>
                <div class="field" v-else>
                    <a class="go-pro" @click="goToPro()"></a>
                </div>
                <div class="tip">{{ trans('hide_profile_completely_tip') }}  
              </div>
            </div>
            <div class="row" id="show-who-favorite-me">
              <div class="title" @click="showWhoFavoriteMeUsers">{{ trans('who_marked_me_favorite') }}</div>
              <div class="field" @click="showWhoFavoriteMeUsers" v-if="userIsPro">
                <i class="open"></i>
              </div>
              <div class="field" v-else>
                <a class="go-pro" @click="goToPro()"></a>
              </div>
            </div>
        </div>
        <div class="box">
            <div class="headline" v-if="!isApp || user.push_notifications">{{ trans('notifications') }}</div>
            <div class="row" v-if="isApp && user.push_notifications">
                <div class="title">{{ trans('push_notifications') }}</div>
                <div class="field">
                    <div class="toggle-switch">
                        <input type="checkbox" id="push-notifications"
                            v-model="user.push_notifications"
                            name="push_notifications"
                            @change="userUpdate">
                        <label for="push-notifications">
                            <span class="toggle-track"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('notification_sound') }}</div>
                <div class="field">
                    <div class="toggle-switch">
                        <input type="checkbox" id="notification-sound"
                            v-model="user.notification_sound"
                               true-value="yes"
                               false-value="no"
                            name="notification_sound"
                            @change="userUpdate">
                        <label for="notification-sound">
                            <span class="toggle-track"></span>
                        </label>
                    </div>
                </div>
            </div>
          <div class="row">
            <div class="title">{{ trans('web_push_notifications') }}</div>
            <div class="field">
              <div class="toggle-switch">
                <input type="checkbox" id="web-push-notifications"
                       v-model="user.web_push_notifications"
                       name="web_push_notifications"
                       @change="userUpdate">
                  <label for="web-push-notifications">
                  <span class="toggle-track"></span>
                </label>
              </div>
            </div>
          </div>
            <div class="row">
                <div class="title">{{ trans('subscribe_to_newsletter') }}</div>
                <div class="field">
                    <div class="toggle-switch">
                        <input type="checkbox" id="newsletter"
                               true-value="yes"
                               false-value="no"
                               v-model="user.subscribed"
                            name="subscribed"
                            @change="userUpdate">
                        <label for="newsletter">
                            <span class="toggle-track"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('emails_reminders') }}</div>
                <div class="field">
                    <select id="email-summary" class="form-control no-swiping"
                        v-model="user.email_reminders"
                        name="email_reminders"
                        @change="saveProfileChange">
                        <option value="daily">{{ trans('daily') }}</option>
                        <option value="weekly">{{ trans('weekly') }}</option>
                        <option value="monthly">{{ trans('monthly') }}</option>
                        <option value="never">{{ trans('never') }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
              <div class="title">{{ trans('timezone') }}</div>
              <div class="field timezone">
                <select id="timezone_utc" class="form-control no-swiping"
                        v-model="user.timezone_utc"
                        name="timezone_utc"
                        @change="saveProfileChange">
                  <option v-for="(timezone, utc) in timezones" :value="utc">{{ utc !== 'UTC' ? utc + ' | ' + timezone : timezone }}</option>
                </select>
                <i class="lock-icon" @click="changeTimezoneType" :class="{locked: user.timezone_type === 'manual',opened: user.timezone_type === 'automatic'}"></i>
              </div>
            </div>
        </div>
        <div class="box">
            <div class="headline">{{ trans('preferences') }}</div>
            <div class="row">
                <div class="title">{{ trans('show_age') }}</div>
                <div class="field">
                    <div class="toggle-switch">
                        <input type="checkbox" id="show-age"
                            v-model='user.show_age'
                               true-value="yes"
                               false-value="no"
                            name="show_age"
                            @change="userUpdate">
                        <label for="show-age">
                            <span class="toggle-track"></span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="title">{{ trans('language') }}</div>
                <div class="field">
                    <select id="language" class="form-control no-swiping" @change="changeLanguage" name="language">
                        <option :selected="appLanguage == 'en'" value="en">{{ trans('english') }}</option>
                        <option :selected="appLanguage == 'de'" value="de">{{ trans('german') }}</option>
                        <option :selected="appLanguage == 'fr'" value="fr">{{ trans('french') }}</option>
                        <option :selected="appLanguage == 'it'" value="it">{{ trans('italian') }}</option>
                        <option :selected="appLanguage == 'nl'" value="nl">{{ trans('dutch') }}</option>
                        <option :selected="appLanguage == 'es'" value="es">{{ trans('spanish') }}</option>
                        <option :selected="appLanguage == 'pt'" value="pt">{{ trans('portuguese') }}</option>
                    </select>
                </div>
            </div>
          <div class="row">
            <div class="title">{{ trans('unit_system') }}</div>
            <div class="field">
              <select id="unit-system" class="form-control no-swiping"
                      v-model="user.unit_system"
                      name="unit_system"
                      @change="saveProfileChange">
                <option value="metric">{{ trans('metric') }}</option>
                <option value="imperial">{{ trans('imperial') }}</option>
              </select>
            </div>
          </div>
          <div class="row" v-if="canChangeDesignType">
            <div class="title">{{ trans('website_design') }}</div>
            <div class="field">
              <select id="website-design" class="form-control no-swiping"
                      v-model="user.deisgn_type"
                      name="deisgn_type"
                      @change="changeWebsiteDesign">
                <option value="old">{{ trans('old') }}</option>
                <option value="new">{{ trans('new') }}</option>
              </select>
            </div>
          </div>
          <div class="row" id="customize-sharing-links">
            <div class="title pointer"
                 @click="goTo('/profile/customize-sharing-links')"
                 v-if="isMobile">{{ trans('customize_sharing_links') }}</div>
            <div class="title" @click="openCustomizeSharingLinks" v-else="!isMobile">{{ trans('customize_sharing_links') }}</div>
          </div>
        </div>
        <div class="box">
            <div class="headline">{{ trans('reset') }}</div>
            <div class="row" id="unblock-all-users">
                <div class="title" @click="showBlockedUsers">{{ trans('unblock_users') }}</div>
            </div>
          <div class="row" id="deactivate-or-delete-profile">
            <div class="title" @click="goTo('/profile/deactivate')" v-if="isMobile">{{ trans('deactivate_or_delete_my_profile') }}</div>
            <div class="title" @click="openProfileDeactivation" v-else="!isMobile">{{ trans('deactivate_or_delete_my_profile') }}</div>
          </div>
          <div class="row" id="delete-all-sharing-links">
            <div class="title" @click="goTo('/profile/delete_all_sharing_links')" v-if="isMobile">{{ trans('delete_all_sharing_links') }}</div>
            <div class="title" @click="openDeleteAllSharingLinks" v-else="!isMobile">{{ trans('delete_all_sharing_links') }}</div>
          </div>
            <div class="row">
                <div id="logout" class="field" @click="logout">
                    <span class="button logout"></span>
                    <span class="label">{{ trans('logout') }}</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="headline">Like and share here</div>
            <div class="row">
                <ul class="socials">
                    <li class="instagram">
                        <a href="https://instagram.com/buddy_net" rel="noopener noreferrer"></a>
                    </li>
                    <li class="facebook">
                        <a href="https://facebook.com/buddydate" rel="noopener noreferrer"></a>
                    </li>
                    <li class="twitter">
                        <a href="https://twitter.com/buddy_net" rel="noopener noreferrer"></a>
                    </li>
                    <li class="tiktok">
                        <a href="https://www.tiktok.com/@buddy.net" rel="noopener noreferrer"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
    import DatePickerComponent from '@buddy/views/widgets/DatePickerComponent.vue';
    import Map from '@buddy/views/widgets/Map.vue';
import axios from "axios";
import auth from "@general/lib/auth";

    export default {
      mixins: [require('@general/lib/mixin').default],
      components: {
        DatePickerComponent,
        Map,
      },
      computed: {
        ...mapGetters({
          timezones: 'timezones'
        }),
        ...mapState({
          user: 'profile',
          userIsPro: 'userIsPro',
        }),
        emailVerificationEnabled(){
          return window.EMAIL_VERIFICATION_ENABLED;
        },
        canChangeDesignType() {
          return true;

          if (!this.user || !this.user.id || !window.DESIGN_TYPE_USERS) {
            return false;
          }
          return window.DESIGN_TYPE_USERS
            .split(',')
            .map(id => id.trim())
            .filter(id => id.length > 0)
            .includes(String(this.user.id));
        }
      },
      methods: {
        ...mapActions([
          'requirementsAlertShow',
          'openProfileDeactivation',
          'openDeleteAllSharingLinks',
          'openCustomizeSharingLinks',
          'closeProfileSettings',
        ]),
        changeTimezoneType(){
          let updateFields =  {timezone_type: this.user.timezone_type === 'automatic' ? 'manual' : 'automatic'};
          axios.post('/api/updateUser', updateFields)
          app.$store.commit('updateUser',updateFields)
          if( this.user.timezone_type !== 'automatic'){
            this.showSuccessNotification(this.trans('timezone_type_manually'));
          }else{
            this.showSuccessNotification(this.trans('timezone_type_automatic'));
          }
        },
        userUpdate(event) {
          event.target.value = !this.user[event.target.name] || this.user[event.target.name] == 'no' ? 0 : 1;
          this.saveProfileChange(event, true);
        },
        showPasswordForm() {
          app.$emit('show-password-form');
        },
        startAgeVerification() {
          app.$store.commit('setModal', { verify_age: true });
        },
        showBlockedUsers() {
          if (app.isDesktop) {
            app.$emit('show-blocked-users');
          } else {
            this.goTo('/profile/unblock-users');
          }
        },
        openVerifyEmailModal(){
          if(!this.user.email_verified){
            app.$store.commit('setModal', { verify_email: true });
          }
        },
        setSensitive(sensitive,platform){
          let media = '';
          let events = '';
          let self = this;
          if(!self.userIsPro && sensitive === 'explicit' && platform === 'app'){
            self.goToPro();
            return '';
          }

          switch(platform){
            case 'app':
              media = 'app_view_sensitive_media';
              events = 'app_view_sensitive_events';
              break;
            case 'web':
              media = 'web_view_sensitive_content';
              events = 'web_view_sensitive_events';
              break;
          }
          switch(sensitive){
            case 'safe':
              self.user[media] = 'no';
              self.user[events] = 'no';
              break;
            case 'sensitive':
              self.user[media] = 'no';
              self.user[events] = 'yes';
              break;
            case 'explicit':
              self.user[media] = 'yes';
              self.user[events] = 'yes';
              break;
          }
          let data = {};
          data[media] = self.user[media] === 'yes';
          data[events] = self.user[events] === 'yes';

          this.saveProfileChange({target:false}, platform === 'web', data)
            .then(response => {
              console.log('UPDATE SENSITIVE CONTENT SUCCESS', response);
            })
            .catch(error => {
              console.error('UPDATE SENSITIVE CONTENT ERROR', error);
              if(error === 'Confirm your age'){
                self.user[media] = 'no';
                self.user[events] = 'no';
                self.startAgeVerification();
              }
            });
        },
        goToPro(){
          if (app.isDesktop) {
            this.closeProfileSettings();
            this.$store.dispatch('updateSidebarVisibility', {index: 'profile', value: false})
          }
          this.goTo('/profile/pro')
        },
        showWhoFavoriteMeUsers(){
          if (app.isDesktop) {
            app.$emit('show-who-marked-me-favorite');
          } else {
            this.goTo('/profile/marked-me-favorite');
          }
        },
        changeLanguage(event) {
          app.setLanguage(event.target.value)
          this.saveProfileChange(event)
        },
        changeWebsiteDesign(event) {
          let value = event.target.value;
          this.saveProfileChange(event)
            .then(() => {
              if (value === 'new') {
                let token = auth.getToken();
                if (!token && axios.defaults.headers.common['Authorization']) {
                  token = axios.defaults.headers.common['Authorization'].replace(/^Bearer\s+/i, '');
                }
                if (token) {
                  let storage = auth._getStorage ? auth._getStorage() : localStorage;
                  storage.setItem('token', token);
                  if (this.user && this.user.id) {
                    storage.setItem('userId', this.user.id);
                  }
                }
                let rnWebDomain = (window.RN_WEB_DOMAIN || '').replace(/\/$/, '');
                window.location.href = `${rnWebDomain}/silentauth?authtoken=${token}&next=%2Fdiscover%3Fpanel%3Dmenu%26sub%3Dsettings`;
              }
            });
        },
        unblockUsers() {
          app.showLightLoading(true);

          axios.post('/api/unblockUsers').then(() => {
            app.showLightLoading(false);
            app.$store.commit('setBlockedCount', 0)
            this.showSuccessNotification('all_users_unblocked');
          });
        }
      },
    }
</script>
